(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/grid/assets/javascripts/debug.js') >= 0) return;  svs.modules.push('/components/tur/grid/assets/javascripts/debug.js');

'use strict';

const {
  useState
} = React;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  env
} = svs.core.config.data.svsconfig;
const Icon = svs.ui.ReactIcon;
const Debug = () => {
  const [showGrid, setShowGrid] = useState(false);
  if (env === 'production') {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tur-grid-toggle ".concat(showGrid ? 'tur-grid-toggle--active' : ''),
    onClick: () => setShowGrid(prevState => !prevState),
    type: "div"
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: "rows"
  })), React.createElement("div", {
    className: "tur-debug-grid ".concat(showGrid ? 'tur-grid--show' : '')
  }, React.createElement("div", {
    className: "grid-wrapper"
  }, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  })), React.createElement(GridCol, {
    am: {
      col: 1
    },
    lg: {
      col: 1
    },
    md: {
      col: 1
    },
    sm: {
      col: 1
    },
    xl: {
      col: 1
    },
    xs: 1
  }, React.createElement("div", {
    className: "placeholder-grid"
  }))))), React.createElement("div", {
    className: "grid-cols-wrapper"
  }, React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })), React.createElement("div", {
    className: "grid-col"
  }, React.createElement("div", {
    className: "placeholder"
  })))));
};
svs.tur.grid.Debug = Debug;

 })(window);